module.exports = __webpack_public_path__ + "static/img/bs-pool-hall.ce82a1f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bs-pool-hall.jpg
// module id = 191
// module chunks = 0